module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Webuild Vietnam","short_name":"webuild","start_url":"/","background_color":"#ffffff","theme_color":"#34785C","display":"minimal-ui","icon":"src/assets/favicons/favicon-v2.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
